(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('ComplainOnSmsDialogController', ComplainOnSmsDialogController);

    ComplainOnSmsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ComplainOnSms'];

    function ComplainOnSmsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ComplainOnSms) {
        var vm = this;

        vm.complainOnSms = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.complainOnSms.id !== null) {
                ComplainOnSms.update(vm.complainOnSms, onSaveSuccess, onSaveError);
            } else {
                ComplainOnSms.save(vm.complainOnSms, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('telestatApp:complainOnSmsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.complainTime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
